export default __webpack_public_path__ + "static/media/card-arrow.43858d45.png";